import React, { useContext } from 'react';
import useMemoObject from './useMemoObject';

// this context provides custom components that can be accessed everywhere in the chart
// this way forwarding a components object prop – which would trigger updates – can be avoided

const ComponentsContext = React.createContext<any>({});

export const ComponentsContextProvider = ({ children, components = {} }: any) => {
  const value = useMemoObject(components);
  return <ComponentsContext.Provider value={value}>{children}</ComponentsContext.Provider>;
};
export const useComponentsContext = () => useContext(ComponentsContext); // constant
